<template>
  <div class="columns">
    <div class="column">
      <sc-field
        prop="pi_numbers"
        label="Número de Pi"
      >
        <sc-taginput
          v-model="filters.pi_numbers"
          placeholder="Inserir os números"
          maxtags="500"
        />
      </sc-field>
    </div>

  </div>
</template>

<script>
import {
  ScField,
  ScSelect,
  ScTaginput,
} from '@intelipost-js/secure-components';

export default {
  name: 'filter-by-pi-number',
  props: {
    filters: {
      type: Object,
    },
    rules: {
      type: Object,
    },
  },
  components: {
    ScField,
    ScSelect,
    ScTaginput,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-refund/features/export-xls/components/FilterByPiNumber.vue?2004ac33